<template>
  <div role="tabpanel" class="tab-pane data-panel" id="data">
    <ul class="nav nav-pills">
      <li class="active"><a data-toggle="tab" href="#profile">Profile</a></li>
      <li>
        <a data-toggle="tab" href="#licence" data-test="org-licence-overview"
          >Subscription overview</a
        >
      </li>
    </ul>

    <div class="tab-content">
      <div id="profile" class="tab-pane fade in active">
        <div style="margin: 2rem 0">
          <p>
            <a :href="`/admin/crmexport/orgdata/${model.id}`" data-test="gd-data-export-link"
              >Data Export</a
            >
          </p>
          <p>
            <a :href="'/organisation/heatmap/' + model.id" target="_blank" rel="noopener noreferrer"
              >Organisation Heatmap</a
            >
          </p>

          <p>
            <a :href="'/organisation/report/' + model.id" target="_blank" rel="noopener noreferrer"
              >View Organisation Report</a
            >
          </p>
          <p>
            <a :href="scratchpadLink" data-test="org-scratchpad-link">Go to scratchpad ✨</a>
          </p>
        </div>
      </div>
      <div id="licence" class="tab-pane fade">
        <SubscriptionOverview
          :subscriptions="model.subscriptions"
          @revalidate-org-data="revalidateOrgData"
        ></SubscriptionOverview>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { OrganisationAndMembersApiModel } from "../../../api-models";
import SubscriptionOverview from "./subscription-overview.vue";

const props = defineProps<{ model: OrganisationAndMembersApiModel }>();
const emit = defineEmits(["revalidate-org-data"]);

const scratchpadLink = computed(() => {
  const url = new URL("/scratchpad", window.location.origin);
  url.searchParams.set("subject", "Org");
  url.searchParams.set("id", props.model.id.toString());
  return url.href;
});

const revalidateOrgData = () => {
  emit("revalidate-org-data");
};
</script>

<style scoped lang="less">
.data-panel {
  margin-top: 2rem;
}
</style>
